import { render, staticRenderFns } from "./resume-row.vue?vue&type=template&id=5c6e87d1&scoped=true"
import script from "./resume-row.vue?vue&type=script&lang=js"
export * from "./resume-row.vue?vue&type=script&lang=js"
import style0 from "./resume-row.vue?vue&type=style&index=0&id=5c6e87d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e87d1",
  null
  
)

export default component.exports